export default {
  setAccountConfig(state, data) {
    state.accountConfig = data;
  },

  setCommodityCategories(state, data) {
    state.commodityCategories = data;
  },

  setCommodityCategoryCode(state, data) {
    state.commodityCategoryCode = data;
  },
  setCommodity(state, data) {
    state.commodity = data;
  },

  setCommodityMaxCode(state, data) {
    state.commodityMaxCode = data;
  },

  setCommodityById(state, data) {
    state.commodityById = data;
  },

  setDealType(state, data) {
    state.dealType = data;
  },
  setDealTypeById(state, data) {
    state.dealTypeById = data;
  },

  setCottage(state, data) {
    state.cottage = data;
  },
  setCottageById(state, data) {
    state.cottageById = data;
  },
  setCottageMaxCode(state, data) {
    state.cottageMaxCode = data;
  },

  setPurchase(state, data) {
    state.purchase = data;
  },
  setPurchaseById(state, data) {
    state.purchaseById = data;
  },

  setOrder(state, data) {
    state.order = data;
  },
  setOrderById(state, data) {
    state.orderById = data;
  },
  setOrderMaxCode(state, data) {
    state.orderMaxCode = data;
  },

  setLading(state, data) {
    state.lading = data;
  },
  setLadingById(state, data) {
    state.ladingById = data;
  },

  setCottageReport(state, data) {
    state.cottageReport = data;
  },
  setPurchaseReport(state, data) {
    state.purchaseReport = data;
  },
  setOrderReport(state, data) {
    state.orderReport = data;
  },
  setComprehensiveOrderReport(state, data) {
    state.comprehensiveOrderReport = data;
  },
};
